// Default error message
const DEFAULT_ERROR_MSG = "Something went wrong !!!";
const WEGLOT_KEY = "wg_c0e869e958586a718205a184019383407";
const DEFAULT_LANGUAGE = "en";
export { DEFAULT_ERROR_MSG, WEGLOT_KEY,DEFAULT_LANGUAGE};
